module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "text",
    class: [_vm.data.props.severity]
  }, [(_vm.data.label) ? _c('table', {
    staticClass: "text-table"
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.data.label) + "\n          "), (_vm.data.props.footnotes) ? _c('footnotes', {
    attrs: {
      "all-footnotes": _vm.footnotes,
      "local-footnotes": _vm.data.props.footnotes
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('td', _vm._l((_vm.data.lines), function(line) {
    return _c('p', [_vm._v("\n            " + _vm._s(line.text) + "\n          ")])
  }), 0)])]) : _vm._l((_vm.data.lines), function(line) {
    return _c('p', {
      staticStyle: {
        "display": "inline"
      }
    }, [_vm._v("\n      " + _vm._s(line.text) + "\n      "), (_vm.data.props.footnotes) ? _c('footnotes', {
      attrs: {
        "all-footnotes": _vm.footnotes,
        "local-footnotes": _vm.data.props.footnotes
      }
    }) : _vm._e()], 1)
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06f8a34a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/approval/field-types/TEXT.vue
// module id = 652
// module chunks = 0